<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h2 class="font-weight-regular">Sponsor destacado:</h2>
          </v-col>

          <v-col cols="12" class="pl-4">
            <label><b>Tipo de Sponsor Destacado:</b> {{ type_sponsor.name }}</label>
          </v-col>

          <v-col cols="12">
            <v-divider class="border-opacity-100" ></v-divider>
          </v-col>
          

          <v-col cols="12" xl="4" md="4" sm="12">
            <v-img
              :src="url_logo"
              height="120px"
              max-width="100%"
              contain>
              
            </v-img>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <label for="name" class="font-weight-bold">Nombre:</label>
            <p>{{ sponsor.name }}</p>

            <label for="web" class="font-weight-bold">Web Institucional:</label>
            <p>
              <a :href="sponsor.web" target="_blank">
                {{ (sponsor.web)?sponsor.web:'--' }}
              </a>  
            </p>
            
          </v-col>
          
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'featuredSponsorsEdition', params: { edition_id:this.edition_id, types_feature_sponsor_id: this.types_feature_sponsor_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'showFeaturedSponsorEdition',

    data: () => ({
      loading:true,

      sponsor:[],
      type_sponsor:[],

      edition_id: null,
      types_feature_sponsor_id: null,
      feature_sponsor_id: null,
    }),

    methods:{
      async getFeaturedSponsorEdition(){
        await axios.get('admin/editions/'+this.edition_id+'/types-featured-sponsors/'+this.types_feature_sponsor_id+'/featured-sponsors/'+this.feature_sponsor_id).then(response =>{
          this.sponsor = response.data.data.sponsor
          this.type_sponsor = response.data.data.type_sponsor

          this.name = this.sponsor.name
          this.web = this.sponsor.web

          this.logo = this.sponsor.logo
          this.url_logo = APP_URL+ this.logo

          this.loading=false
          this.show=true
        }).catch(error => {
          console.log(error);
        })
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id
      this.types_feature_sponsor_id = this.$route.params.types_feature_sponsor_id
      this.feature_sponsor_id = this.$route.params.feature_sponsor_id
      this.getFeaturedSponsorEdition()
    },
  }
</script>
